import { render, staticRenderFns } from "./feitian.vue?vue&type=template&id=4ab9f190&scoped=true"
import script from "./feitian.vue?vue&type=script&lang=js"
export * from "./feitian.vue?vue&type=script&lang=js"
import style0 from "./feitian.vue?vue&type=style&index=0&id=4ab9f190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab9f190",
  null
  
)

export default component.exports